import controller from './vd-banner.controller'
import template from './vd-banner.html'

const BannerComponent = {
  bindings: {
    type: '@',
  },
  transclude: {
    feedback: '?vdFeedback',
  },
  controller,
  template,
}

export default BannerComponent
